import React from 'react';
import { CheckCircle2, ArrowRight, ShieldCheck, Download, Zap, Brain, Target, Users, BookOpen, Clock } from 'lucide-react';
import { Accordion } from './Accordion';
import { Testimonials } from './Testimonials';
import { FAQ } from './FAQ';
import { CountdownTimer } from './CountdownTimer';
const CHECKOUT_LINK = 'https://checkout.sectordigital.online/cart/44251351580715:1';
const modules = [{
  prefix: 'MÓDULO 1',
  title: 'COMPRENDER LAS ALTAS CAPACIDADES EN CLÍNICA',
  content: <div className="space-y-4" data-id="element-40">
        <p data-id="element-41">
          Ubicá clínicamente el perfil sin caer en mitos, reduccionismos o
          explicaciones generales.
        </p>
        <p className="font-semibold text-slate-800" data-id="element-42">
          Este módulo te ayuda a trabajar:
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-43">
          <li data-id="element-44">qué lugar ocupan las altas capacidades en la consulta;</li>
          <li data-id="element-45">
            diferencia entre altas capacidades, talento, alto rendimiento y buen
            desempeño;
          </li>
          <li data-id="element-46">formas de presentación clínica;</li>
          <li data-id="element-47">mitos frecuentes;</li>
          <li data-id="element-48">asincronía;</li>
          <li data-id="element-49">desajuste con el entorno;</li>
          <li data-id="element-50">sufrimiento subjetivo;</li>
          <li data-id="element-51">riesgos de idealizar o patologizar.</li>
        </ul>
        <div className="bg-blue-50 p-4 rounded-lg mt-4 border border-blue-100" data-id="element-52">
          <p className="font-bold text-blue-900 mb-1" data-id="element-53">Resultado del módulo:</p>
          <p className="text-blue-800" data-id="element-54">
            vas a tener una base clínica clara para comprender el perfil sin
            reducir al paciente a una etiqueta.
          </p>
        </div>
      </div>
}, {
  prefix: 'MÓDULO 2',
  title: 'EVALUACIÓN INICIAL Y FORMULACIÓN DEL PERFIL',
  content: <div className="space-y-4" data-id="element-55">
        <p data-id="element-56">
          Ordená la primera entrevista y construí hipótesis clínicas con mayor
          precisión.
        </p>
        <p className="font-semibold text-slate-800" data-id="element-57">
          Este módulo te ayuda a evaluar:
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-58">
          <li data-id="element-59">motivo de consulta;</li>
          <li data-id="element-60">historia evolutiva;</li>
          <li data-id="element-61">historia escolar o laboral;</li>
          <li data-id="element-62">funcionamiento cognitivo percibido;</li>
          <li data-id="element-63">regulación emocional;</li>
          <li data-id="element-64">rendimiento y bajo rendimiento;</li>
          <li data-id="element-65">aburrimiento;</li>
          <li data-id="element-66">perfeccionismo;</li>
          <li data-id="element-67">vínculos;</li>
          <li data-id="element-68">camuflaje;</li>
          <li data-id="element-69">adaptación social;</li>
          <li data-id="element-70">señales de doble excepcionalidad;</li>
          <li data-id="element-71">riesgo clínico;</li>
          <li data-id="element-72">necesidad de derivación o interconsulta.</li>
        </ul>
        <div className="bg-blue-50 p-4 rounded-lg mt-4 border border-blue-100" data-id="element-73">
          <p className="font-bold text-blue-900 mb-1" data-id="element-74">Resultado del módulo:</p>
          <p className="text-blue-800" data-id="element-75">
            vas a poder formular el caso con más criterio antes de decidir la
            intervención.
          </p>
        </div>
      </div>
}, {
  prefix: 'MÓDULO 3',
  title: 'INTENSIDAD EMOCIONAL Y REGULACIÓN INTERNA',
  content: <div className="space-y-4" data-id="element-76">
        <p data-id="element-77">
          Intervení cuando el paciente entiende lo que le pasa, pero no logra
          regularlo.
        </p>
        <p className="font-semibold text-slate-800" data-id="element-78">Este módulo trabaja:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-79">
          <li data-id="element-80">saturación mental;</li>
          <li data-id="element-81">pensamiento acelerado;</li>
          <li data-id="element-82">frustración;</li>
          <li data-id="element-83">irritabilidad;</li>
          <li data-id="element-84">sensibilidad interpersonal;</li>
          <li data-id="element-85">reactividad emocional;</li>
          <li data-id="element-86">rumiación;</li>
          <li data-id="element-87">regulación corporal;</li>
          <li data-id="element-88">descarga y clasificación mental;</li>
          <li data-id="element-89">tolerancia emocional;</li>
          <li data-id="element-90">plan personal de regulación.</li>
        </ul>
        <div className="bg-blue-50 p-4 rounded-lg mt-4 border border-blue-100" data-id="element-91">
          <p className="font-bold text-blue-900 mb-1" data-id="element-92">Resultado del módulo:</p>
          <p className="text-blue-800" data-id="element-93">
            vas a contar con herramientas para trabajar intensidad emocional sin
            patologizarla ni minimizarla.
          </p>
        </div>
      </div>
}, {
  prefix: 'MÓDULO 4',
  title: 'PERFECCIONISMO, SOBREEXIGENCIA Y MIEDO AL ERROR',
  content: <div className="space-y-4" data-id="element-94">
        <p data-id="element-95">
          Trabajá el alto estándar cuando empieza a bloquear, agotar o
          condicionar la identidad del paciente.
        </p>
        <p className="font-semibold text-slate-800" data-id="element-96">Este módulo aborda:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-97">
          <li data-id="element-98">perfeccionismo adaptativo y desadaptativo;</li>
          <li data-id="element-99">miedo al error;</li>
          <li data-id="element-100">procrastinación por alto estándar;</li>
          <li data-id="element-101">bloqueo;</li>
          <li data-id="element-102">evitación;</li>
          <li data-id="element-103">autocrítica;</li>
          <li data-id="element-104">identidad basada en rendimiento;</li>
          <li data-id="element-105">dificultad para aprender desde cero;</li>
          <li data-id="element-106">flexibilización de estándares;</li>
          <li data-id="element-107">exposición gradual al error.</li>
        </ul>
        <div className="bg-blue-50 p-4 rounded-lg mt-4 border border-blue-100" data-id="element-108">
          <p className="font-bold text-blue-900 mb-1" data-id="element-109">Resultado del módulo:</p>
          <p className="text-blue-800" data-id="element-110">
            vas a poder intervenir cuando la exigencia deja de orientar y
            empieza a paralizar.
          </p>
        </div>
      </div>
}, {
  prefix: 'MÓDULO 5',
  title: 'ABURRIMIENTO, MOTIVACIÓN Y BÚSQUEDA DE SENTIDO',
  content: <div className="space-y-4" data-id="element-111">
        <p data-id="element-112">
          Diferenciá aburrimiento, desmotivación, baja estimulación, evitación,
          burnout o depresión.
        </p>
        <p className="font-semibold text-slate-800" data-id="element-113">Este módulo trabaja:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-114">
          <li data-id="element-115">aburrimiento por baja estimulación;</li>
          <li data-id="element-116">aburrimiento por repetición;</li>
          <li data-id="element-117">falta de sentido;</li>
          <li data-id="element-118">intereses intensos;</li>
          <li data-id="element-119">motivación intrínseca;</li>
          <li data-id="element-120">tareas poco estimulantes;</li>
          <li data-id="element-121">dispersión entre múltiples intereses;</li>
          <li data-id="element-122">diseño de desafíos graduados;</li>
          <li data-id="element-123">activación conductual adaptada;</li>
          <li data-id="element-124">sostenimiento de rutinas necesarias.</li>
        </ul>
        <div className="bg-blue-50 p-4 rounded-lg mt-4 border border-blue-100" data-id="element-125">
          <p className="font-bold text-blue-900 mb-1" data-id="element-126">Resultado del módulo:</p>
          <p className="text-blue-800" data-id="element-127">
            vas a poder trabajar el aburrimiento como dato clínico, no como
            simple falta de voluntad.
          </p>
        </div>
      </div>
}, {
  prefix: 'MÓDULO 6',
  title: 'IDENTIDAD, DIFERENCIA Y ADAPTACIÓN SOCIAL',
  content: <div className="space-y-4" data-id="element-128">
        <p data-id="element-129">
          Acompañá al paciente cuando su funcionamiento se mezcla con camuflaje,
          sobreadaptación o sensación de no encajar.
        </p>
        <p className="font-semibold text-slate-800" data-id="element-130">Este módulo trabaja:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-131">
          <li data-id="element-132">historia de diferencia;</li>
          <li data-id="element-133">sensación de no pertenecer;</li>
          <li data-id="element-134">camuflaje;</li>
          <li data-id="element-135">sobreadaptación;</li>
          <li data-id="element-136">costo social;</li>
          <li data-id="element-137">vínculos de alta exigencia;</li>
          <li data-id="element-138">identidad basada en rendimiento;</li>
          <li data-id="element-139">comunicación de necesidades;</li>
          <li data-id="element-140">límites;</li>
          <li data-id="element-141">autenticidad gradual;</li>
          <li data-id="element-142">pertenencia sin borrarse.</li>
        </ul>
        <div className="bg-blue-50 p-4 rounded-lg mt-4 border border-blue-100" data-id="element-143">
          <p className="font-bold text-blue-900 mb-1" data-id="element-144">Resultado del módulo:</p>
          <p className="text-blue-800" data-id="element-145">
            vas a poder intervenir sin reforzar superioridad, rareza ni
            adaptación a cualquier costo.
          </p>
        </div>
      </div>
}, {
  prefix: 'MÓDULO 7',
  title: 'DIAGNÓSTICO DIFERENCIAL Y DOBLE EXCEPCIONALIDAD',
  content: <div className="space-y-4" data-id="element-146">
        <p data-id="element-147">
          Ordená hipótesis cuando aparecen solapamientos con otras condiciones.
        </p>
        <p className="font-semibold text-slate-800" data-id="element-148">
          Este módulo trabaja la diferenciación prudente entre altas capacidades
          y:
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-149">
          <li data-id="element-150">TDAH;</li>
          <li data-id="element-151">TEA;</li>
          <li data-id="element-152">ansiedad;</li>
          <li data-id="element-153">depresión;</li>
          <li data-id="element-154">TOC;</li>
          <li data-id="element-155">trauma;</li>
          <li data-id="element-156">dificultades de aprendizaje;</li>
          <li data-id="element-157">alto rendimiento como máscara;</li>
          <li data-id="element-158">bajo rendimiento como máscara;</li>
          <li data-id="element-159">doble excepcionalidad;</li>
          <li data-id="element-160">criterios de derivación;</li>
          <li data-id="element-161">interconsulta;</li>
          <li data-id="element-162">comunicación de hipótesis al paciente o familia.</li>
        </ul>
        <div className="bg-blue-50 p-4 rounded-lg mt-4 border border-blue-100" data-id="element-163">
          <p className="font-bold text-blue-900 mb-1" data-id="element-164">Resultado del módulo:</p>
          <p className="text-blue-800" data-id="element-165">
            vas a poder diferenciar sin reducir y sostener hipótesis clínicas
            abiertas con mayor responsabilidad profesional.
          </p>
        </div>
      </div>
}, {
  prefix: 'MÓDULO 8',
  title: 'PLAN DE INTERVENCIÓN Y SEGUIMIENTO TERAPÉUTICO',
  content: <div className="space-y-4" data-id="element-166">
        <p data-id="element-167">Convertí la evaluación en un proceso clínico con dirección.</p>
        <p className="font-semibold text-slate-800" data-id="element-168">
          Este módulo te ayuda a ordenar:
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-169">
          <li data-id="element-170">focos terapéuticos;</li>
          <li data-id="element-171">priorización clínica;</li>
          <li data-id="element-172">objetivos observables;</li>
          <li data-id="element-173">plan por fases;</li>
          <li data-id="element-174">herramientas según el caso;</li>
          <li data-id="element-175">tareas entre sesiones;</li>
          <li data-id="element-176">seguimiento de avances;</li>
          <li data-id="element-177">coordinación con familia, escuela, trabajo o interdisciplina;</li>
          <li data-id="element-178">ajustes ante estancamiento;</li>
          <li data-id="element-179">prevención de recaídas;</li>
          <li data-id="element-180">criterios de cierre.</li>
        </ul>
        <div className="bg-blue-50 p-4 rounded-lg mt-4 border border-blue-100" data-id="element-181">
          <p className="font-bold text-blue-900 mb-1" data-id="element-182">Resultado del módulo:</p>
          <p className="text-blue-800" data-id="element-183">
            vas a poder pasar de la comprensión del perfil a un proceso
            terapéutico claro, medible y aplicable.
          </p>
        </div>
      </div>
}];
function scrollToPurchase() {
  const target = document.getElementById('compra');
  // Use window.scrollTo with the element's absolute offset instead of
  // scrollIntoView({ behavior: 'smooth' }) — the latter throws
  // "smooth scroll behavior is not fully supported with dynamic size"
  // inside virtualized preview containers and can lock scrolling.
  const top = target ? target.getBoundingClientRect().top + window.scrollY : 0;
  try {
    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  } catch {
    window.scrollTo(0, top);
  }
}
export function SalesPage() {
  const handleBuyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    scrollToPurchase();
  };
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-800" data-id="element-184">
      {/* Hero Section */}
      <header className="bg-gradient-to-b from-blue-900 to-blue-950 text-white min-h-screen flex flex-col justify-center py-8 sm:py-12 px-5 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-185">
        <div className="max-w-5xl mx-auto text-center relative z-10 w-full" data-id="element-186">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 sm:mb-7 leading-tight" data-id="element-187">
            UN SISTEMA CLÍNICO PARA INTERVENIR EN PACIENTES CON{' '}
            <span className="text-blue-400" data-id="element-188">ALTAS CAPACIDADES</span>
          </h1>

          {/* Main Product Image — directly under the headline */}
          <div className="flex justify-center mb-4 sm:mb-5" data-id="element-189">
            <img src="https://cdn.magicpatterns.com/uploads/crwnVQmnko3kMQz1P5NBuV/agrega_un_parrafo_en_la_seccion_1_y_2_parrafos_en_la_seccion_2_(1).png" alt="Kit Psicología en Altas Capacidades" className="w-[83%] sm:w-[48%] max-w-[440px] h-auto transform hover:scale-[1.02] transition-transform duration-500 cursor-pointer" onClick={scrollToPurchase} data-id="element-190" />
          </div>

          {/* Promise subtitle */}
          <p className="text-sm sm:text-base text-blue-200/90 max-w-2xl mx-auto mb-6 sm:mb-7 leading-snug line-clamp-2" data-id="element-191">
            Sistema clínico-práctico para psicólogos que trabajan con pacientes
            con altas capacidades
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-7 sm:mb-10" data-id="element-192">
            <a href="#compra" onClick={handleBuyClick} className="w-full sm:w-auto bg-amber-500 hover:bg-amber-400 text-amber-950 font-bold text-lg px-8 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-193">
              SÍ, QUIERO EL KIT AHORA
              <ArrowRight className="w-5 h-5" data-id="element-194" />
            </a>
          </div>

          <div className="grid grid-cols-2 sm:flex sm:flex-wrap justify-center gap-x-4 gap-y-2.5 sm:gap-6 md:gap-12 text-xs sm:text-sm font-medium text-blue-200 max-w-md sm:max-w-none mx-auto" data-id="element-195">
            <div className="flex items-center gap-2" data-id="element-196">
              <Zap className="w-4 h-4 sm:w-5 sm:h-5 text-amber-400 flex-shrink-0" data-id="element-197" />{' '}
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2" data-id="element-198">
              <ShieldCheck className="w-4 h-4 sm:w-5 sm:h-5 text-amber-400 flex-shrink-0" data-id="element-199" />{' '}
              Pago único y seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-200">
              <Download className="w-4 h-4 sm:w-5 sm:h-5 text-amber-400 flex-shrink-0" data-id="element-201" />{' '}
              Material descargable
            </div>
            <div className="flex items-center gap-2" data-id="element-202">
              <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-amber-400 flex-shrink-0" data-id="element-203" />{' '}
              Listas para usar
            </div>
          </div>
        </div>
      </header>

      {/* Method Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-204">
        <div className="max-w-4xl mx-auto" data-id="element-205">
          <div className="text-center mb-16" data-id="element-206">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-207">
              MÉTODOS CLINICOS COMPROBADOS
            </h2>
            <p className="text-lg text-slate-600" data-id="element-208">
              El kit está organizado bajo metodologías comprobadas, en una
              estructura clínica para transformar el conocimiento sobre altas
              capacidades en intervención concreta.
            </p>
            <p className="text-lg font-bold text-slate-800 mt-4" data-id="element-209">
              El método trabaja 3 preguntas centrales:
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-210">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center" data-id="element-211">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mb-6" data-id="element-212">
                <Brain className="w-6 h-6 text-blue-700" data-id="element-213" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-214">
                ¿Cómo funciona este paciente?
              </h3>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center" data-id="element-215">
              <div className="bg-amber-100 w-12 h-12 rounded-full flex items-center justify-center mb-6" data-id="element-216">
                <Target className="w-6 h-6 text-amber-700" data-id="element-217" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-218">
                ¿Qué costo tiene ese funcionamiento?
              </h3>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center" data-id="element-219">
              <div className="bg-emerald-100 w-12 h-12 rounded-full flex items-center justify-center mb-6" data-id="element-220">
                <Users className="w-6 h-6 text-emerald-700" data-id="element-221" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-222">
                ¿Qué intervención necesita?
              </h3>
            </div>
          </div>
        </div>
      </section>

      {/* Modules Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-223">
        <div className="max-w-5xl mx-auto" data-id="element-224">
          <div className="text-center mb-16" data-id="element-225">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-226">
              QUÉ INCLUYE EL KIT
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-227">
              Accedés a 8 módulos clínico-prácticos y 3 bonus profesionales para
              trabajar con más estructura desde la evaluación hasta el
              seguimiento terapéutico.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-228">
            {modules.map((mod, i) => <Accordion key={i} prefix={mod.prefix} title={mod.title} data-id="element-229">
                {mod.content}
              </Accordion>)}
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900 text-white relative overflow-hidden" data-id="element-230">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-231">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-500 rounded-full blur-3xl" data-id="element-232"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-amber-500 rounded-full blur-3xl" data-id="element-233"></div>
        </div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-234">
          <div className="text-center mb-16" data-id="element-235">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-236">
              BONUS PROFESIONALES INCLUIDOS
            </h2>
            <p className="text-xl text-slate-300" data-id="element-237">
              Además de los 8 módulos, te llevás 3 bonus pensados para usar como
              apoyo clínico y recurso práctico.
            </p>
            <div className="inline-block bg-amber-500 text-amber-950 font-bold px-6 py-2 rounded-full mt-6 animate-pulse" data-id="element-238">
              ¡GRATIS POR EL DÍA DE HOY!
            </div>
          </div>

          <div className="space-y-8" data-id="element-239">
            <div className="bg-slate-800/50 border border-slate-700 p-8 rounded-2xl backdrop-blur-sm" data-id="element-240">
              <h3 className="text-2xl font-bold text-amber-400 mb-4 flex items-center gap-3" data-id="element-241">
                <BookOpen className="w-6 h-6" data-id="element-242" />
                BONUS #1 GUÍA DE PSICOEDUCACIÓN PARA PACIENTES CON ALTAS
                CAPACIDADES
              </h3>
              <p className="text-slate-300 mb-4" data-id="element-243">
                Una presentación PDF para explicar al paciente, de forma clara y
                accesible, qué implica este perfil dentro de un encuadre
                profesional.
              </p>
              <p className="text-amber-200 mt-4 italic" data-id="element-244">
                Ideal para usar en sesión como recurso psicoeducativo.
              </p>
            </div>

            <div className="bg-slate-800/50 border border-slate-700 p-8 rounded-2xl backdrop-blur-sm" data-id="element-245">
              <h3 className="text-2xl font-bold text-amber-400 mb-4 flex items-center gap-3" data-id="element-246">
                <BookOpen className="w-6 h-6" data-id="element-247" />
                BONUS #2 PLANTILLA DE EVALUACIÓN INICIAL EN ALTAS CAPACIDADES
              </h3>
              <p className="text-slate-300 mb-4" data-id="element-248">
                Una herramienta práctica para ordenar la primera entrevista.
              </p>
              <div className="mt-6 bg-slate-700/50 p-4 rounded-lg border border-slate-600" data-id="element-249">
                <p className="text-white font-medium" data-id="element-250">
                  No es un test diagnóstico.
                </p>
                <p className="text-slate-300" data-id="element-251">
                  Es una guía para evaluar mejor y formular con más criterio.
                </p>
              </div>
            </div>

            <div className="bg-slate-800/50 border border-slate-700 p-8 rounded-2xl backdrop-blur-sm" data-id="element-252">
              <h3 className="text-2xl font-bold text-amber-400 mb-4 flex items-center gap-3" data-id="element-253">
                <BookOpen className="w-6 h-6" data-id="element-254" />
                BONUS #3 BANCO DE INTERVENCIONES PARA MENTE INTENSA
              </h3>
              <p className="text-slate-300 mb-4" data-id="element-255">
                Un banco de herramientas clínicas aplicables en sesión.
              </p>
              <p className="text-amber-200 mt-2 italic bg-amber-900/30 p-3 rounded-lg border border-amber-800/50 inline-block" data-id="element-256">
                Cada intervención está pensada para elegirse según la
                formulación del caso, no por etiqueta.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Target Audience Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-blue-50" data-id="element-257">
        <div className="max-w-3xl mx-auto" data-id="element-258">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-slate-900 mb-12" data-id="element-259">
            ESTE KIT ES PARA VOS SI...
          </h2>
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-blue-100" data-id="element-260">
            <p className="text-lg text-slate-700 mb-6 font-medium" data-id="element-261">
              Este kit es para vos si sos psicólogo/a y:
            </p>
            <ul className="space-y-4" data-id="element-262">
              {['trabajás con pacientes con altas capacidades o sospecha de altas capacidades;', 'ya conocés el perfil, pero necesitás una estructura de intervención;', 'recibís pacientes muy analíticos, intensos o sobreexigidos;', 'querés abordar camuflaje, adaptación social y sensación de no encajar;', 'querés tener un sistema organizado para evaluar, formular, intervenir y hacer seguimiento.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-263">
                  <CheckCircle2 className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-264" />
                  <span className="text-slate-700 text-lg" data-id="element-265">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* Offer / Purchase Section */}
      <section id="compra" className="py-6 sm:py-12 px-4 sm:px-6 lg:px-8 bg-slate-100" data-id="element-266">
        <div className="max-w-sm mx-auto" data-id="element-267">
          <div className="bg-white rounded-3xl overflow-hidden shadow-2xl border border-slate-200" data-id="element-268">
            {/* Dark top: title + includes */}
            <div className="bg-slate-900 px-5 pt-5 pb-4 text-center" data-id="element-269">
              <h2 className="text-lg sm:text-xl font-extrabold text-white tracking-tight leading-snug" data-id="element-270">
                KIT PSICOLOGÍA EN ALTAS CAPACIDADES™
              </h2>
              <p className="text-emerald-400 font-semibold text-sm mt-0.5 mb-3" data-id="element-271">
                Acceso inmediato y de por vida
              </p>
              <ul className="space-y-1.5 text-left max-w-xs mx-auto" data-id="element-272">
                {['Módulo principal de Abordaje en Altas Capacidades', 'Bonus #1 — Guía de Psicoeducación', 'Bonus #2 — Plantilla de Evaluación Inicial', 'Bonus #3 — Banco de Intervenciones', 'Herramientas, plantillas y protocolos'].map(item => <li key={item} className="flex items-start gap-2 text-slate-200 text-[13px] leading-snug" data-id="element-273">
                    <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-274" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* White bottom: countdown, prices, CTA */}
            <div className="px-5 py-5 text-center" data-id="element-275">
              <CountdownTimer data-id="element-276" />

              <div className="mt-3 mb-2" data-id="element-277">
                <span className="inline-flex items-center gap-1.5 bg-red-50 text-red-600 text-xs font-bold px-3 py-1 rounded-full border border-red-100" data-id="element-278">
                  <Clock className="w-3.5 h-3.5" data-id="element-279" />
                  Oferta por tiempo limitado
                </span>
              </div>

              <div data-id="element-280">
                <span className="text-lg text-slate-400 line-through decoration-2" data-id="element-281">
                  $49.990
                </span>
              </div>
              <div className="flex items-end justify-center gap-1.5" data-id="element-282">
                <span className="text-4xl font-extrabold text-slate-900 tracking-tight" data-id="element-283">
                  $19.990
                </span>
                <span className="text-base font-semibold text-slate-500 mb-0.5" data-id="element-284">
                  ARS
                </span>
              </div>
              <p className="text-slate-500 text-xs mb-4" data-id="element-285">
                Pago único. Sin suscripciones.
              </p>

              <a href={CHECKOUT_LINK} className="block w-full bg-emerald-500 hover:bg-emerald-600 text-white font-bold text-base sm:text-lg px-6 py-3.5 rounded-xl shadow-lg shadow-emerald-500/30 hover:shadow-emerald-500/50 transition-all transform hover:-translate-y-0.5" data-id="element-286">
                SÍ, QUIERO EL KIT AHORA
              </a>

              <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 mt-4 text-[11px] font-medium text-slate-500" data-id="element-287">
                <div className="flex items-center gap-1.5" data-id="element-288">
                  <ShieldCheck className="w-3.5 h-3.5 text-emerald-500" data-id="element-289" /> Pago
                  único
                </div>
                <div className="flex items-center gap-1.5" data-id="element-290">
                  <Download className="w-3.5 h-3.5 text-emerald-500" data-id="element-291" /> Acceso
                  inmediato
                </div>
                <div className="flex items-center gap-1.5" data-id="element-292">
                  <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" data-id="element-293" />{' '}
                  Material digital descargable
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FAQ data-id="element-294" />
      <Testimonials data-id="element-295" />

      {/* Footer */}
      <footer className="bg-slate-950 text-slate-400 py-12 px-4 sm:px-6 lg:px-8 text-sm text-center border-t border-slate-900" data-id="element-296">
        <div className="max-w-4xl mx-auto" data-id="element-297">
          <p data-id="element-298">
            © 2026 KIT Psicología en Altas Capacidades™. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </div>;
}